import React, {} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {SIDEBAR_HIDDEN_BUTTONS, SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import {toggleChangeLayoutPopup} from "../../../../../../../actions/sqftFunctions";
import NavMiteredSection from "./toolMitered/navMiteredSection";

const SqftNavMitered = (props) => {
  const {miteredSections, menuOpened, activeSubMenuButton} = props;
  const expanded = (menuOpened === SIDEBAR_NAVIGATION_BUTTONS.mitered || activeSubMenuButton === SIDEBAR_HIDDEN_BUTTONS.buttonMitered)
    && miteredSections.length > 0;
  const sectionName = <FormattedMessage id='sqft.navigation.mitered.title'/>;

  return (
    <div className={"content side-level2 side" + (expanded ? " expanded" : "")} >
      <div className="mitered-sections">
        {
          miteredSections.map((miteredSection, index) => {
            if (!miteredSection) {
              return
            }
            return <NavMiteredSection sectionName={sectionName} miteredSection={miteredSection} index={index} key={index}/>
          })
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    miteredSections: store.sqftMiteredState.miteredSections,
    activeSubMenuButton: store.sqftMenuState.activeSubMenuButton,
  };
};

const mapDispatchToProps = {
  toggleChangeLayoutPopup
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavMitered);
